import { PHOTO_BRIEFS } from '../data/photoBriefs';
import { PHOTO_ASSETS } from '../data/photoAssets';
import './PhotoSlots.css';

export const photoKey = value => encodeURIComponent(String(value));

// Owner-approved photos fill their space; the rest stay a labeled blank space
// showing which picture belongs there. Very small spaces show the short label.
export default function PhotoSlot({ id, label, className = '', sizes, ...props }) {
  const photo = PHOTO_ASSETS[id];
  const imageSizes = sizes || photo?.sizes;
  if (photo) {
    return <span {...props} className={`dv-photo-slot dv-photo-slot--filled ${className}`} data-photo-slot={id} data-photo-label={label}>
      <picture>
        {photo.webpSrcSet && <source type="image/webp" srcSet={photo.webpSrcSet} sizes={imageSizes} />}
        <img src={photo.src} srcSet={photo.srcSet} sizes={photo.srcSet ? imageSizes : undefined} alt={photo.alt}
          width={photo.width} height={photo.height} loading="lazy" decoding="async" style={{ objectPosition: photo.focus }} />
      </picture>
    </span>;
  }
  const brief = PHOTO_BRIEFS[id];
  return <span {...props} className={`dv-photo-slot ${className}`} data-photo-slot={id} data-photo-label={label} role="img" aria-label={label}>
    <span className="dv-photo-slot__label dv-size-body">
      {brief ? <><span className="dv-photo-slot__brief">{brief}</span><span className="dv-photo-slot__name">{label}</span></> : <span>{label}</span>}
      <small>Photo space · {id}</small>
    </span>
  </span>;
}
